import { AgGridReact } from "ag-grid-react";
import {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import AsyncSelect from "react-select/async";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SyncUtils } from "../../utils/SyncUtils";
import Select from "react-select";
import AgProductSearchEditor from "./AgProductSearchEditor";
import AgProductRenderor from "./AgProductRenderor";
import { AgentUtils } from "../../utils/AgentUtils";
import { createStyles, Theme } from "@mui/material/styles";
import "./ag-grid-style.css";

export default function TSaleListRo(props) {
  const [rowData] = useState(getRows(500));

  const [gridApi, setGridApi] = useState();
  const gridRef = useRef();

  const { t } = useTranslation();
  const translate = t;

  const rowClassRules = useMemo(() => {
    return {
      // row style function
      selected_sale: (params) => {
        return params.data.selected;
        //var numSickDays = params.data.sickDays;
        //return numSickDays > 5 && numSickDays <= 7;
      },
      // row style expression
    };
  }, []);

  useEffect(() => {
    if (props.saleData.length > 0) {
      updateAgGrid(gridRef.current.api);
    } else {
      clearGrid();
    }
  }, [props.saleData, gridRef.current]);

  useEffect(() => {}, [props.saleData]);

  var biRef = {};

  props.biRef.saleListAg = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "getCurrentRow") {
      if (gridRef.current && gridRef.current.api) {
        return gridRef.current.api.getSelectedNodes();
      }
    }
  }

  function clearGrid() {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.setRowData(getRows(500));
    }
  }

  async function updateAgGrid(api) {
    const agGridData = [];

    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.forEachNodeAfterFilterAndSort(function (
        rowNode,
        index
      ) {
        const data = rowNode.data;
        agGridData.push(data);
      });
      let itemsToUpdate = [];
      let i = 0;
      let selectedIx = 0;

      for (let d of props.saleData) {
        if (!isMatching(d, agGridData[i])) {
          itemsToUpdate.push(getAgGridData(d, agGridData[i]));
        }
        if (d[9].info.selected) {
          selectedIx = i;
        }
        i++;
      }

      for (let j = i; j < 500; j++) {
        let exists = isDataFound(agGridData, j);
        if (exists) {
          itemsToUpdate.push(getBlankData(agGridData[j]));
        }
      }
      //Reconcile
      if (itemsToUpdate.length > 0) {
        const res = gridRef.current.api.applyTransaction({
          update: itemsToUpdate,
        });
      }

      gridRef.current.api.ensureIndexVisible(selectedIx);
      //gridRef.current.api.autoSizeAllColumns();
      //
    }
  }

  function getTableBodyHeight() {
    if (props.context.appMode === "desktop-pos") {
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 240 : 170)
        ).toString() + "px"
      );
    } else {
      return (
        (
          AgentUtils.getWindowDimensionsExAppBarsDualMode(props.context.appMode)
            .h - (props.saleType === "SERVICE" ? 260 : 160)
        ).toString() + "px"
      );
    }
  }

  function isDataFound(agGridData, i) {
    if (agGridData[i].product) {
      return true;
    }
    if (agGridData[i].unitType) {
      return true;
    }
    if (agGridData[i].price) {
      return true;
    }
    if (agGridData[i].discountPer) {
      return true;
    }
    if (agGridData[i].discountAmt) {
      return true;
    }
    if (agGridData[i].tax) {
      return true;
    }
    if (agGridData[i].amount) {
      return true;
    }
    return false;
  }

  function isMatching(sd, ag) {
    if (ag.product == undefined) {
      return false;
    } else if (sd[2].v != ag.product.prodBean.name) {
      return false;
    } else if (sd[9].info.selected != ag.selected) {
      return false;
    } else if (sd[3].v != ag.price) {
      return false;
    } else if (sd[4].v != ag.unitType) {
      return false;
    } else if (sd[5].v != ag.qty) {
      return false;
    } else if (sd[6].v != ag.discountPer) {
      return false;
    } else if (sd[7].v != ag.tax) {
      return false;
    } else if (sd[8].v != ag.amount) {
      return false;
    }
    return true;
  }

  function getBlankData(agRow) {
    agRow["product"] = null;
    agRow["unitType"] = null;
    agRow["qty"] = null;
    agRow["price"] = null;
    agRow["discountPer"] = null;
    agRow["discountAmt"] = null;
    agRow["tax"] = null;
    agRow["amount"] = null;
    agRow["selected"] = false;
  }
  function getAgGridData(d, agRow) {
    agRow["product"] = {
      prodBean: d[9].info.productBean,
      pricingBean: d[9].info.pricingBean,
      info: d[9].info,
    };
    agRow["unitType"] = d[4].v;
    agRow["qty"] = d[5].v;
    agRow["price"] = d[3].v;
    agRow["discountPer"] = d[6].v;
    agRow["discountAmt"] = d[9].info.discountAmount;
    agRow["tax"] = d[7].v;
    agRow["amount"] = d[8].v;
    agRow["selected"] = d[9].info.selected ? true : false;
    return agRow;
  }

  function getRows(count) {
    let arr = [];
    for (let i = 0; i < count; i++) {
      arr.push({ id: i + 1 });
    }
    return arr;
  }

  function onProductSelected(prodBean, pricingBean, rowId) {
    props.onAddProduct(prodBean, pricingBean, rowId);
  }

  const defaultColDef = useMemo(() => {
    return {
      cellStyle: {
        fontSize: "13px",
        paddingLeft: "7px",
        paddingRight: "7px",
      },
      headerStyle: {
        fontSize: "11px",
        paddingLeft: "7px",
        paddingRight: "7px",
      },
      //wrapText: true,
    };
  }, []);

  const columnDefs = [
    {
      headerName: "SN",
      field: "id",
      width: 55,
      editable: false,
    },
    {
      headerName: "Item",
      field: "product.prodBean.name",
      //cellRenderer: AgProductRenderor,
      //cellEditorPopup: true,
      editable: false,
      width: 180,
      //width: 180,
      wrapText: true,
    },
    {
      headerName: "Unit",
      field: "unitType",
      //cellEditorPopup: true,
      flex: 1,
      width: 65,
      editable: false,
    },
    {
      headerName: "Qty",
      field: "qty",
      //width: 65,
      flex: 1,
      //cellEditorPopup: true,
      editable: false,
      type: "rightAligned",
    },
    {
      headerName: "Price",
      field: "price",
      flex: 1,
      //width: 70,
      //cellEditorPopup: true,
      editable: false,
      type: "rightAligned",
    },
    {
      headerName: "Disc",
      field: "discountAmt",
      flex: 1,
      //cellEditorPopup: true,
      editable: false,
      //width: 70,
      type: "rightAligned",
    },
    {
      headerName: "Tax",
      field: "tax",
      flex: 1,
      type: "rightAligned",
      //width: 70,
      //cellEditorPopup: true,
    },
    {
      headerName: "Amt",
      field: "amount",
      flex: 1,
      //width: 100,
      //cellEditorPopup: true,
      type: "rightAligned",
    },
  ];

  /*const onCellValueChanged = (event) => {
    if (event.column.colId === "qty") {
      props.onChangeValueEvent(event.value, "updateQty", event.rowIndex);
    } else if (event.column.colId === "price") {
      props.onChangeValueEvent(event.value, "updatePrice", event.rowIndex);
    } else if (event.column.colId === "product") {
      handleProuctNameChangeEvent(event);
    } else if (event.column.colId === "discountAmt") {
      props.onChangeValueEvent(
        event.value,
        "updateDiscountAmount",
        event.rowIndex
      );
    } else if (event.column.colId === "discountPer") {
      props.onChangeValueEvent(
        event.value,
        "updateDiscountPer",
        event.rowIndex
      );
    }
  };*/

  /*function handleProuctNameChangeEvent(event) {
    let d = props.saleData[event.rowIndex];
    if (d) {
      console.log(d, event);
      if (d[9].info.productBean.id != event.value.prodBean.id) {
        console.log("Need Update");
        let dd = event.data;
        dd.product = {
          prodBean: d[9].info.productBean,
          pricingBean: d[9].info.pricingBean,
        };
        let itemsToUpdate = [];
        itemsToUpdate.push(dd);
        const res = gridRef.current.api.applyTransaction({
          update: itemsToUpdate,
        });
      }
    }
  }*/

  const onGridReady = (e) => {
    setGridApi(e.api);
  };
  function onSelectionChanged() {
    const selectedRows = gridRef.current.api.getSelectedRows();

    let arr = [...props.saleData];

    resetSelection(arr, selectedRows[0].id - 1);
    props.setSaleData(arr);
  }

  function resetSelection(data, rowIndex) {
    // props.setSelectedSaleItemIndex(rowIndex);
    for (let i = 0; i < data.length; i++) {
      if (rowIndex == i) {
        data[i][9].info.selected = true;
        data[i][5].focus = true;
      } else {
        data[i][9].info.selected = false;
        data[i][5].focus = false;
      }
    }
  }

  function onCellKeyDown(e) {
    console.log(e);
    var backspaceEvnt = new KeyboardEvent("keypress", e.event);
    if (e.event.keyCode != 13) document.dispatchEvent(backspaceEvnt);
  }

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: getTableBodyHeight(), width: "100%" }}
    >
      <AgGridReact
        onGridReady={onGridReady} // register event listener
        ref={gridRef}
        rowData={rowData}
        columnDefs={columnDefs}
        //onCellValueChanged={onCellValueChanged}
        rowSelection="single"
        defaultColDef={defaultColDef}
        rowClassRules={rowClassRules}
        onSelectionChanged={onSelectionChanged}
        onCellKeyDown={onCellKeyDown}
      ></AgGridReact>
    </div>
  );
}
